<script context="module">
	import { writable } from 'svelte/store';
	export const nav = writable({})
</script>

<script>
  function makeRegex(key) {
		return (key||'').replaceAll(/\/\:(\w+)/g,'/(?<$1>.*)').replaceAll('/','\\/')
	}

	function navigate() {
		 if (!$nav['/']||!$nav['*']) {
			console.error("missing default '/' and '*' paths")
		 }

		$nav._loc = $nav._loc||''
		let key = $nav._loc.substr($nav._loc.indexOf('/'));
		 let found = $nav[key]
		 if (found) {
			 $nav._current = key;
			 $nav._params = undefined;
		 } else {
			  if ($nav._loc) {
					for(let key of Object.keys($nav).filter(k => k.indexOf(':')>-1)) {
						let matched = $nav._loc.match(new RegExp(makeRegex(key)))
						if (matched) {
							$nav._current = key;
							if (matched.groups) {
								for(let k in matched.groups) {
									matched.groups[k] = decodeURIComponent(matched.groups[k])
								}
							}
							$nav._params = matched.groups;
							return;
						}
					}
					$nav._current = '*'
					$nav._params = undefined
				} else {
					$nav._loc = '#/'
          $nav._current = '/'
					$nav._params = undefined
				}
		 }
	}

	function hashchange() {
    $nav._loc = window.location.hash
		// $nav=$nav
	}

	$:{
     navigate($nav)
	}
    hashchange()
</script>

{#if $nav._params}
<svelte:component params={$nav._params} this={$nav[$nav._current]}/>
{:else}
<svelte:component this={$nav[$nav._current]}/>
{/if}
<svelte:window on:hashchange={hashchange}/>
